import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SlAIService } from './sl-ai.service';
import { SlServicesModule } from '../sl-services/sl-services.module';




@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        SlServicesModule,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    providers: [
        SlAIService,
    ]
})
export class SlAIModule { }
